import load from 'little-loader';
import getSections from '../utils/get-sections';

const defaultSdkCDN = 'https://sb.scorecardresearch.com/beacon.js';

const convert = (params) => {
    const { section, subSection } = params.content.section
        ? getSections(params.content.section)
        : {};
    const { c1, c2 } = params.config.comScore;

    return {
        c1, // Tag type
        c2, // comScore client id
        c4: window.location.toString(), // full page url
        c5: `${subSection}`, // Genre of content
        c6: `${section}`, // Package
    };
};

export default ({ cdn = defaultSdkCDN, trackerId = 'comScore' } = {}) => ({
    track(params) {
        return new Promise((resolve, reject) => {
            if (!params) {
                return reject(new Error('Tracking params must be specified'));
            }

            /* eslint no-underscore-dangle: [2, { "allow": ["_comscore"] }] */
            window._comscore = [];
            window._comscore.push(convert(params));

            load(cdn, (err) => {
                if (err) {
                    return reject(err);
                }

                return resolve({
                    response: 'comScore tracking completed.',
                    params,
                    trackerId,
                });
            });

            return undefined;
        });
    },
});



/** WEBPACK FOOTER **
 ** ./src/tracking/comScore-tracker.js
 **/